module.exports = __webpack_public_path__ + "img/ep-6-9-dosis.981900d0.jpg";